const cardItems = [
  {
    title: '从选秀到顶流：那些年我们追过的偶像',
    desc: '回顾近五年选秀节目走出的顶流明星，他们的成长轨迹与粉丝经济的变迁，值得每一位追星人深入了解。',
    img: 'https://readdy.ai/api/search-image?query=Stage%20performance%20silhouette%20with%20spotlight%20and%20rising%20stars%20illustration%2C%20warm%20coral%20amber%20gradient%2C%20modern%20minimal%20editorial%20style%2C%20clean%20inspiring%20composition&width=800&height=500&seq=cards-01&orientation=landscape',
    date: '2026-07-28',
    tag: '深度',
  },
  {
    title: '综艺节目的幕后故事：你不知道的那些事',
    desc: '综艺节目录制现场的趣事、未被播出的片段、以及制作团队的心路历程，带你走进综艺制作的幕后世界。',
    img: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20TV%20studio%20illustration%20with%20cameras%20and%20equipment%2C%20warm%20coral%20amber%20tones%2C%20modern%20minimal%20style%2C%20clean%20professional%20look&width=800&height=500&seq=cards-02&orientation=landscape',
    date: '2026-07-27',
    tag: '揭秘',
  },
  {
    title: '2026上半年娱乐圈关键词大盘点',
    desc: '恋情、离婚、翻红、塌房……2026年上半年娱乐圈十大关键词，每一个背后都有说不完的故事。',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20word%20cloud%20and%20keyword%20illustration%20in%20warm%20coral%20amber%20gradient%2C%20modern%20minimal%20design%2C%20editorial%20style%2C%20clean%20vibrant%20composition&width=800&height=500&seq=cards-03&orientation=landscape',
    date: '2026-07-26',
    tag: '盘点',
  },
  {
    title: '影视圈新势力：新生代演员演技大赏',
    desc: '95后、00后新生代演员正在崛起，谁有实力接棒成为下一届影帝影后？全面解析新人的演技与潜力。',
    img: 'https://readdy.ai/api/search-image?query=Film%20clapperboard%20and%20young%20actor%20silhouettes%20illustration%2C%20warm%20coral%20amber%20palette%2C%20modern%20minimal%20editorial%20style%2C%20clean%20cinematic%20feel&width=800&height=500&seq=cards-04&orientation=landscape',
    date: '2026-07-25',
    tag: '解析',
  },
  {
    title: '明星公益行动：娱乐圈的正能量时刻',
    desc: '盘点近期明星参与的公益活动与慈善项目，看看哪些艺人用实际行动回馈社会，传递温暖与正能量。',
    img: 'https://readdy.ai/api/search-image?query=Heartwarming%20community%20and%20charity%20illustration%20with%20helping%20hands%2C%20warm%20coral%20amber%20gradient%2C%20modern%20minimal%20style%2C%20clean%20uplifting%20composition&width=800&height=500&seq=cards-05&orientation=landscape',
    date: '2026-07-24',
    tag: '正能量',
  },
  {
    title: '吃瓜进阶指南：如何辨别真假娱乐新闻',
    desc: '在信息爆炸的时代，假新闻和营销号层出不穷，教你几招快速辨别真假娱乐新闻的实用技巧。',
    img: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20newspaper%20illustration%20in%20warm%20coral%20amber%20tones%2C%20modern%20minimal%20editorial%20style%2C%20clean%20professional%20look&width=800&height=500&seq=cards-06&orientation=landscape',
    date: '2026-07-23',
    tag: '指南',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">深度吃瓜</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">精选深度文章，吃瓜也要有深度</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item) => (
            <div key={item.title} className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 text-xs px-2 py-0.5 rounded bg-accent-500 text-background-50 whitespace-nowrap font-medium">{item.tag}</span>
              </div>
              <div className="p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3 mb-3">{item.desc}</p>
                <span className="text-xs text-foreground-400">{item.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}